import styled from "@emotion/styled";
import { colorGuide, colorPalette } from "../../theme/colors";

export const StepperContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  position: relative;
`;

export const StepRow = styled.div`
  display: inline-flex;
  padding: 10px 20px;
  align-items: flex-start;
  gap: 8px;
`;

export const StepNumber = styled.div`
  width: 20px;
  height: 20px;
  color: white;
  background-color: ${colorGuide.lightComponents.stepper.stepBackground};
  font-size: 12px;
  font-weight: 500;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  flex-shrink: 0;
  font-family: Rubik;
  line-height: 15px;
  text-align: center;
  z-index: 2;
`;

export const DashedLine = styled.div`
  position: absolute;
  left: 30px;
  top: 28px;
  height: 40px;
  width: 1px;
  background: repeating-linear-gradient(
    to bottom,
    ${colorGuide.lightComponents.stepper.stepBackground},
    ${colorGuide.lightComponents.stepper.stepBackground} 3px,
    transparent 3px,
    transparent 6px
  );
  z-index: 1;
`;

export const StepContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const DescriptionText = styled.p`
  font-style: italic;
  font-size: 12px;
  font-family: Rubik;
  font-weight: 400;
  line-height: 15px;
  color: ${colorGuide.lightComponents.stepper.descriptionColor};
  text-align: left;
`;
